import FaqComponent from 'components/Common/FaqComponent/FaqComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import './Faq.css';

function Faq() {
  return (
    <div className="faq-page layout-full-height">
      <Header />

      <ContainerComponent className="layout-main-content">
        <>
          <FaqComponent />
        </>
      </ContainerComponent>

      <Footer />
    </div>
  );
}

export default Faq;
